import React, { useContext, useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import classes from "./Navbar.module.scss";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import {  MenuItem, Skeleton,Select } from "@mui/material";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import { useTranslation } from 'react-i18next';
import Button from "../UI/Button";
import { useForm } from "react-hook-form";
import WarningTooltip from "../profileComponents/WarningTooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ErrorAlert from "../UI/ErrorAlert";
import SuccessAlert from "../UI/SuccessAlert";
import { ThreeDots } from "react-loader-spinner";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import BusinessIcon from '@mui/icons-material/Business';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import InfoIcon from '@mui/icons-material/Info';
import LinkIcon from '@mui/icons-material/Link';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const e2Data = new E2Data("EU_PluginRequests");
const iconStyle = {fontSize:"1.2rem"}


const SendMailRequest = ({onHiddenChange, onAddNewCompany, ...props}) => {
    const { clientType, customerRelation, aboutOrgId, mainOrgId, sessionInfo } = useContext(OrgIdContext);
    const [showUser, setShowUser] = useState(true);
    const [countriesList, setCountriesList] = useState([]);
    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState();
    const [success, setSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [cultures, setCultures] = useState([]);
    const [error, setError] = useState();
    //const [customerFields, setCustomerFields] =  useState({});
    const { t } = useTranslation();

    const customerFields = {
        "Company":{
            group : "basic",
            label : t("Company name"),
            type : "text",
            placeholder : t("Enter company name you wish plugin for"),
            validation : {required:"Customer country is required"},
            subType: <BusinessIcon style={iconStyle}/>,
        },
        "CompanyURL": {
            type : "text",
            label : t("Company URL"),
            placeholder : t("Enter company URL which you wish plugin for"),
            validation : {required:"Customer country is required"},
            subType: <LinkIcon style={iconStyle}/>,
            group : "basic",
        },
        "ReplyEmail": {
            type : "text",
            label : t("Reply email"),
            placeholder: "example@domain.com",
            subType : <AlternateEmailIcon style={iconStyle}/>,
            validation : {
                required: t("Email Address is required"),
                pattern: {
                    value: /^\S+@\S+\.\S+$/i,
                    message: t("Invalid email address"),
                }},
            group : "basic",
        },
        "Message" :{
            type : "textarea",
            label : t("Extra info"),
            placeholder : "Enter any extra information regarding the plugin",
            subType : <InfoIcon style={iconStyle}/>,
            group : "basic",
        },
    }

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
    } = useForm(/*defaultone*/);


    const getValidation = (fieldInfo) =>{
        if(fieldInfo.MandatoryForCompany)
            return {required: t("This field is required")};
    }

    const getTooltip = (fieldInfo) =>{
        if(fieldInfo.CompanyDesc)
            return fieldInfo.CompanyDesc;
        return null;
    }

    const getCustomerHelper = (fieldName) =>{
        if(!customerFields[fieldName].tooltip)
            return;
        return(
            <OverlayTrigger placement="top" overlay={<Tooltip>{customerFields[fieldName].tooltip}</Tooltip>}>
                <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
        )
    }

    const getErrorMessage = (fieldName) => {
        if(errors[fieldName]){
            return (
                <WarningTooltip text={errors[fieldName].message}/>
            )
        }
    }

    const getCustomerElement = (fieldsObj, fieldName, validation) =>{
        if(fieldsObj[fieldName].subType){
            return(<>
            <div key={"inputEl"+fieldName} className="input-group" style={{flexWrap:"nowrap"}}>
                {getInputElement(
                    fieldName, 
                    fieldsObj[fieldName].type,
                    fieldsObj[fieldName].validation || validation || {},
                    {
                        placeholder: fieldsObj[fieldName].placeholder || ""
                    }
                    )}
                {getSubtypeElement(fieldsObj[fieldName].subType)}
            </div>
            </>)
        }else{
            return getInputElement(fieldName, fieldsObj[fieldName].type, fieldsObj[fieldName].validation || validation || {});
        }
    }

    const getInputElement = (name, type, validation={}, props ) =>{
        if(name==="CustomerCountryCode")
            return getCountriesSelect(name, validation);
        if(name==="CultureCode")
            return getCulturesSelect(name, validation);
        switch(type){
            case "select":
                return(
                    <select
                        {...register(name, validation)}
                        placeholder={customerFields[name].placeholder}
                        style={errors[name] ? {maxWidth:"none",outlineColor:"red"} : {maxWidth:"none"}}
                        >
                            {/* <option key="empty" value={""}>{customerFields[name].placeholder}</option> */}
                            {customerFields[name].validValues && customerFields[name].validValues.map((data, i)=>{
                                return(
                                <option value={data.value} key={i}>
                                    {data["desc"]}
                                </option>)
                            })}
                        </select>
                )
            case "textarea":
                return(
                    <textarea
                    style={errors[name] ? {outlineColor:"red"} :{}}
                    {...register(name, validation)}
                    {...props}
                    />
                )
            default:
                return (
                    <input
                    type="text"
                    style={errors[name] ? {outlineColor:"red"} :{}}
                    {...register(name, validation)}
                    {...props}
                    />
                )
        }
    }
    const getCulturesSelect = (name, validation={}) =>{
        return(
            <Select
            className={classes["mui-select"]}
            style={errors[name] ? {padding:"0px", display:"block", borderRadius:"10px", border:"1px solid red"} : {padding:"0px", display:"block", borderRadius:"10px", border:"1px solid #005683"}}
            sx={{ padding : "0px", boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 }, "& .MuiSelect-select": {paddingRight:"0px"} }}
            {...register(name, validation)}>
                {cultures.map((data, i)=>{
                    return(
                        <MenuItem value={data.Culture} key={i}>
                            <img style={{marginLeft:".5rem"}} alt="" src={(process.env.REACT_APP_ORIGIN || window.location.origin)+"/"+data["FlagIconUrl4x3"]} width="25"/>
                            <span style={{paddingLeft:"1rem"}}>{data["Culture"]}</span>
                        </MenuItem>)
                })}
            </Select>
        )
    }
    const getCountriesSelect = (name, validation={}) =>{
        return (
            <select
            {...register(name, validation)}
            placeholder="Select a country"
            style={errors[name] ? {maxWidth:"none",outlineColor:"red"} : {maxWidth:"none"}}
            >
                <option key="empty" value={""}>{t("Select a country...")}</option>
                {countriesList.map((data, i)=>{
                    return(
                    <option value={data.CountryCodeISOC2} key={i}>
                        {data["CountryNameOriginal"]}
                    </option>)
                })}
            </select>
        )
    }

    const getSubtypeElement = (subType) =>{
        switch(subType){
            default:
                return(
                    <span className="input-group-text" style={{border:"none", outline:"1.5px solid #005683", backgroundColor:"#fbfbfb"}}>
                        {subType}
                    </span>
                )
        }
    }

    const createUserSubmit = (data) =>{
        if(saving)
            return;
        setSaving(true);
        setSaveError(null);
        setSuccess(null);
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.RequestAPlugin", data).then((res) => {
            if(res?.result?.Status==="OK"){
                setSuccess(t("Your request has been sent successfully. We will get back to you soon."));
            }else if(res?.error?.message){
                setSaveError(t("An error occured while sending the request."));
            }else{
                setSaveError(t("An error occured while sending the request. Please try again later."));
            }
        }).finally(() =>{
            setSaving(false);
        });;
        /*e2Data.values = data;
        e2Data.Create(data).then(res =>{
            setSuccess(t("Your request has been sent successfully. We will get back to you soon."));
        }).catch(err =>{
            setError(t("An error occured while sending the request. Please try again later."));
        }).finally(() =>{
            setSaving(false);
        });*/
    }

    return ( 
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          {...props}
        >
          <Modal.Header className={classes.modalHeader}>
            <div className='w-100 d-flex '>
                <div>
                  <CorporateFareIcon style={{fontSize:"2.2rem", marginRight:"1rem"}}/>
                  <span className={classes.modalTitleText}>{t("Send a plugin request")}</span>
                </div>
                <div className="ms-auto">
                  <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}}  onClick={props.onHide} />
                </div>
              </div>
          </Modal.Header>
          <Modal.Body className={classes["modalBody"]}>
            <form className={classes["input-container"]} onSubmit={handleSubmit(createUserSubmit)}>
                {Object.keys(customerFields).map((fieldName, i) => {
                    if(customerFields[fieldName].group !== "basic")
                        return null;
                    return(<>
                    <fieldset key={"fset"+fieldName} className={classes["user-fieldset"]}>
                        <label>
                            {customerFields[fieldName].label || fieldName}
                            {customerFields[fieldName].validation?.required && <span style={{color:"red"}}>*</span>}
                            {getCustomerHelper(fieldName)}
                            {getErrorMessage(fieldName)}
                        </label>
                        {getCustomerElement(customerFields,fieldName)}
                    </fieldset>
                    </>)
                })}
                <div className="text-center pt-3">
                    {saving  && <ThreeDots height="50" width="50" color="#005683" wrapperStyle={{justifyContent:"center"}}/>}
                    {saveError && <ErrorAlert text = {saveError} style={{marginBottom:"1rem"}}/>}
                    {success && <SuccessAlert text = {success} style={{marginBottom:"1rem"}}/>}
                    <Button type="submit" className="px-5 py-1 ms-3" disabled ={saving}>
                        <PersonAddIcon style={{marginRight:"1rem"}}/>
                        {t("Send request")}
                    </Button>
                </div>
            </form>
          </Modal.Body>
        </Modal>
      );
};

export default SendMailRequest;